import { call, put, takeEvery } from "redux-saga/effects";

import {
  GET_FAQS,
  POST_CONTACT_US,
  GET_CONTENT_PAGE,
  GET_IMAGES,
} from "./actionTypes";
import {
  getFaqsFail,
  getFaqsSuccess,
  postContactUsFail,
  postContactUsSuccess,
  getContentPageFail,
  getContentPageSuccess,
  getImagesFail,
  getImagesSuccess,
} from "./actions";

import {
  getFaqs,
  postContactUs,
  getContentPage,
  getImages,
} from "helpers/backend_helper";

function* onGetFaq({ payload: { data, callback } }) {
  try {
    const response = yield call(getFaqs, data);

    if (response.status === "failure") {
      return yield put(getFaqsFail(response.message));
    }

    callback && callback(response);
    yield put(getFaqsSuccess(response.data));
  } catch (error) {
    yield put(getFaqsFail(""));
  }
}

function* onPostContactUs({ payload: { data, callback } }) {
  try {
    const response = yield call(postContactUs, data);

    if (response.status === "failure") {
      return yield put(postContactUsFail(response.message));
    }

    callback && callback(response);
    yield put(postContactUsSuccess(response.data));
  } catch (error) {
    yield put(postContactUsFail(""));
  }
}

function* onGetContentPage({ payload: { data, callback } }) {
  try {
    const response = yield call(getContentPage, data);

    if (response.status === "failure") {
      return yield put(getContentPageFail(response.message));
    }

    callback && callback(response);
    yield put(getContentPageSuccess(response.data));
  } catch (error) {
    yield put(getContentPageFail(""));
  }
}

function* onGetImages({ payload: { data, callback } }) {
  try {
    const response = yield call(getImages, data);

    if (response.status === "failure") {
      return yield put(getImagesFail(response.message));
    }
    callback && callback(response);
    yield put(getImagesSuccess(response.data));
  } catch (error) {
    yield put(getImagesFail(""));
  }
}
function* contentPagesSaga() {
  yield takeEvery(GET_FAQS, onGetFaq);
  yield takeEvery(POST_CONTACT_US, onPostContactUs);
  yield takeEvery(GET_CONTENT_PAGE, onGetContentPage);
  yield takeEvery(GET_IMAGES, onGetImages);
}

export default contentPagesSaga;
